module.exports = __webpack_public_path__ + "static/img/newsf.f406fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsf.png
// module id = uoHd
// module chunks = 45